import { type ReactNode, useId } from 'react';

export interface TextareaProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  rows?: number;
  maxLength?: number;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
  hint?: ReactNode;
  /** The server's translated issue for this field: shown in place of the hint, and the field is marked invalid. */
  error?: ReactNode;
  /** Fixed direction for text in one script. */
  dir?: 'rtl' | 'ltr';
}

/** Multi-line text field in brand chrome. */
export function Textarea({
  label,
  value,
  onChange,
  rows = 3,
  maxLength,
  required,
  disabled,
  placeholder,
  hint,
  error,
  dir,
}: TextareaProps) {
  const id = useId();
  const hintId = `${id}-hint`;
  const note = error ?? hint;
  return (
    <div className={error ? 'fs-field fs-field--invalid' : 'fs-field'}>
      <label className="fs-field__label" htmlFor={id}>
        {label}
      </label>
      <textarea
        id={id}
        className="fs-field__input fs-field__textarea"
        rows={rows}
        value={value}
        maxLength={maxLength}
        required={required}
        disabled={disabled}
        placeholder={placeholder}
        dir={dir}
        aria-invalid={error ? true : undefined}
        aria-describedby={note ? hintId : undefined}
        onChange={(event) => onChange(event.target.value)}
      />
      {note && (
        <span id={hintId} className="fs-field__hint">
          {note}
        </span>
      )}
    </div>
  );
}
